var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{attrs:{"value":_vm.healthy,"ok-label":_vm.$t('servers.healthy'),"ko-label":_vm.$t('servers.unhealthy')}})}
var staticRenderFns = []

export { render, staticRenderFns }